import { Product } from '.';
import { SellingUnit, Variant } from './variant';

export type LineItem = {
  id: string;
  SKU: string;
  name: string;
  productId: string;
  variantId: string;
  orderId: string;
  price: string;
  total: string;
  subTotal: string;
  quantity: string;
  properties: { [key: string]: unknown };
  sellingUnitId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  product: Product;
  variant: Variant;
  sellingUnit: SellingUnit;
};

export const getLineItemsTotal = (lineItems: LineItem[]) => {
  return lineItems.reduce((acc, lineItem) => {
    const total = Number(lineItem.total);
    return acc + total;
  }, 0);
};
